import {Box} from 'src/design/atoms/Box';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {Button} from 'src/design/atoms/Button';
import {Title} from 'src/design/atoms/Title';
import {PageSkeleton} from 'src/design/atoms/PageSkeleton';

interface UnhandledErrorPageProps {
  error: string;
}
const UnhandledErrorPage = ({error}: UnhandledErrorPageProps) => (
  <Stack mt="md" gap="md">
    <Title>
      An error occurred. We are working to fix this issue as soon as possible.
    </Title>

    <PageSkeleton width="70%" />
    <Text c="dimmed">{error}</Text>

    <Box>
      <Button
        aria-label="backToDashboardBtnUI"
        size="lg"
        onClick={() => window.location.assign(PathUtility.Dashboard())}>
        Back to Dashboard
      </Button>
    </Box>
  </Stack>
);

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Error(),
  element: <UnhandledErrorPage error={''} />,
  isPrivate: false,
});

export default UnhandledErrorPage;
